import {inject}             from '@angular/core';
import {DataFactoryService} from '../../../../../logr-services/data/data-factory.service';

export abstract class MenuCrudPanelToggleBase<T> {
	svcDataFactory = inject(DataFactoryService);

	abstract selected: T[];

	protected constructor(private typeKey: keyof typeof this.svcDataFactory['crudDataSvcs']) {

	}

	abstract addRecord(): Promise<void>;

	public toggleItemInSelected(term: T) {
		if (this.selected.includes(term)) {
			this.selected = this.selected.filter(selectedTerm => selectedTerm !== term);
		} else {
			this.selected.push(term);
		}
	}

	public itemInSelected(term: T) {
		return this.selected.includes(term);
	}
}
